import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { CollapsibleList } from '../../../../components';
import { fetchAnswers } from '../../../../stores/actions/alternatives';
import { isNullOrEmptyArray } from '../../../../util/arrays';

function SingleQuestionAwareCollapsibleList({
  /**
   * identificador do cliente selecionado atualmente
   */
  customerId,
  /**
   * identificador da pesquisa selecionada atualmente
   */
  surveyId,
  /**
   * título da pesquisa
   */
  surveyTitle,
  /**
   * identificador da pergunta
   */
  questionId,
  /**
   * enunciado da pergunta
   */
  questionTitle,
  /**
   * define se este componente foi selecionado
   */
  checkedTitle = false,
  /**
   * define se o título deve ser destacado
   */
  boldedTitle = false,
  /**
   * define se o componente expandirá para recuperar alternativas
   */
  expansible = false,
  /**
   * define se o compoente poderá permitir a seleção dos seus itens
   */
  selectableItem = false,
  /**
   * define a lista de itens selecionados
   */
  selectedItems = [/* 1, 2, 3 */],
  /**
   * propaga o evento de selecionar uma questão
   */
  onSelectQuestion,
  /**
   * propaga o evento de selecionar uma alternativa
   */
  onSelectAlternative,
  /**
   * propaga o evento de alteração das alternativas selecionadas
   * params=(questionId, altersId=[])
   */
  onChangeSelectedAlternativesIds,
  /**
   * destaca o item em foco
   */
  highlightFocusItem,
  /**
   * outras propriedades
   */
  ...props
}) {
  // from redux
  const { dispatch, running, error, alternatives, hiddenCheckboxCollapsibleQuestion } = props;

  // state
  const [listItems, setListItems] = useState([]);

  // efeito de atualização das alternativas
  useEffect(() => {
    if (!isNullOrEmptyArray(alternatives) && isNullOrEmptyArray(listItems)) {
      const datas = alternatives.map((a) => ({
        value: a.id,
        label: a.enunciado,
      }));
      setListItems(datas);
    }
  }, [alternatives, listItems]);

  // No caso de haver erro depois que solicitar salvar
  useEffect(() => {
    if (error) {
      toast.error(error.toString());
    }
  }, [error]);

  function handleChangeSelectedItems(items) {
    if (onChangeSelectedAlternativesIds) {
      const altsIds = items.map((item) => item.value);
      onChangeSelectedAlternativesIds(questionId, altsIds);
    }
  }

  function handleSelectedItem(checked, qId) {
    if (onSelectQuestion) onSelectQuestion(checked, qId);
  }

  function handleExpand() {
    if (isNullOrEmptyArray(listItems)) {
      fetchAnswers({ customerId, surveyId, questionId }, dispatch);
    }
  }

  return (
    <CollapsibleList
      className="SingleQuestionAwareCollapsibleList"
      title={questionTitle}
      tooltipTitle={surveyTitle}
      checkedTitle={checkedTitle}
      boldedTitle={boldedTitle}
      expansible={expansible}
      withArrow={expansible}
      checkable={selectableItem}
      selectedValues={selectedItems}
      data={listItems}
      loading={running}
      onSelectTitle={(checked) => handleSelectedItem(checked, questionId)}
      onChangeSelectedItems={(items) => handleChangeSelectedItems(items)}
      onExpand={() => handleExpand()}
      highlightFocusItem
      hiddenCheckboxCollapsibleQuestion={hiddenCheckboxCollapsibleQuestion}
    />
  );
}

/**
 * Mapeia o estado da store para as propriedades que serão passadas para este
 * componente.
 *
 * O estado é "alternatives" que é um mapa de dados cuja chave é o questionId.
 *
 * @param {*} state
 * @param {*} props
 */
const mapStateToProps = (state, props) => {
  // props
  const { customerId, surveyId, questionId } = props;
  // state key
  const key = { customerId, surveyId, questionId };
  // get alternative state by key
  const alternativesState = state.alternatives;
  const currState = alternativesState.get(key);
  // if exists
  return {
    running: currState ? currState.running : false,
    error: currState ? currState.error : null,
    alternatives: currState ? currState.payload : [],
  };
};


// create component (delegate) and export
export default connect(
  mapStateToProps, null, null, { forwardRef: false },
)(SingleQuestionAwareCollapsibleList);
